/* eslint-disable no-undef */
import { fabric } from "fabric";

export default function text(obj) {
  const object = new fabric.IText(
    "Edit text...",
    obj
  );

  // Remove this from here, move to composable
  object.setControlVisible("mt", false);
  object.setControlVisible("mr", false);
  object.setControlVisible("mb", false);
  object.setControlVisible("ml", false);

  return object;
}
